<template>
  <div class="work-hours-vue">
    <p>
      These are your work hours. They should be the hours you are 
      consistantly available. Students will only be able to 
      schedule time with you during the 
      <strong>highlighted timeframes.</strong>

      For more granular control your availability, use the 
      <b>Customize Availability</b> tab to override your regular 
      hours. 

      Please press "Apply" after making changes.
    </p>
    <loader v-show="loading" />
    <div v-show="!loading">
      <div :class="displayCalendars ? '' : 'hideCalendars'" id="cronofy-availability-rules" />
      <div v-if="showTooSmallTimespanWarning">
        <p class="warning">
          You have set one or more spans of recurring hours to less than an hour.
          Sessions require 50 minutes of availability. You may not be able to schedule
          sessions at those times without additional customized availability.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import CounselorClient from '@/api/CounselorClient';
import moment from 'moment';
export default {
  components: {
    Loader,
  },
  data() {
    return {
      counselorClient: new CounselorClient(this.$http),
      loading: true,
      showTooSmallTimespanWarning: false,
    }
  },
  props: {
    counselorId: {
      type: Number,
      required: true,
    },
    displayCalendars: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  async mounted() {
    const response = await this.counselorClient.getManagedAvailabilityToken(this.counselorId);
    this.loading = false;
    CronofyElements.AvailabilityRules({
        target_id: "cronofy-availability-rules",
        element_token: response.token.token,
        availability_rule_id: 'work_hours',
        config: {
          start_time: "08:00",
          end_time: "19:00",
          duration: 30,
          tz_list: [
            // Alaska Time
            'America/Anchorage',
            'America/Juneau',
            'America/Metlakatla',
            'America/Nome',
            'America/Sitka',
            'America/Yakutat',

            // Aleutian Time
            'America/Adak',

            // Central Time
            'America/Chicago',
            'America/Indiana/Knox',
            'America/Indiana/Tell_City',
            'America/Menominee',
            'America/North_Dakota/Beulah',
            'America/North_Dakota/Center',
            'America/North_Dakota/New_Salem',

            // Eastern Time
            'America/New_York',
            'America/Detroit',
            'America/Indiana/Petersburg',
            'America/Indiana/Vincennes',
            'America/Indiana/Winamac',
            'America/Kentucky/Monticello',
            'America/Louisville',
            'America/Indianapolis',
            'America/Indiana/Marengo',
            'America/Indiana/Vevay',

            // Hawaiian Time
            'Pacific/Honolulu',

            // Mountain Time
            'America/Denver',
            'America/Boise',
            'America/Phoenix',

            // Pacific Time
            'America/Los_Angeles',

            // SA Western Time
            'America/Puerto_Rico',
          ],
        },
        translations: {
          en: {
            availability_rules: {
              rules_saved: 'Schedule Updated',
              save_new_rules: "Apply",
            },
          },
        },
        styles: {
          prefix: 'work-hours-viewer',
          colors: {
            primary: "#75fffd",
            hairline: "#5c6877",
            available: "#75fffd",
            availableActive: "#75fffd",
            availableHover: "#75fffd",
            unavailable: "#0f2a45",
          },
        },
        callback: notification => {
          if(!notification || !notification.notification)
            return

          const type = notification.notification.type

          if (type === 'error')
            console.error(notification.notification)
            
          else if (type === 'warn')
            console.warn(notification.notification)
            
          else if (type === 'availability_rule_edited') {
            this.showTooSmallTimespanWarning = false;
            if(!notification.availability_rule.weekly_periods)
              return;
            notification.availability_rule.weekly_periods.forEach(weekly_period => {
              const start = moment(weekly_period.start_time, 'HH:mm');
              const end = moment(weekly_period.end_time, 'HH:mm');
              const diff = end.diff(start, 'minutes');
              if(diff < 50) {
                this.showTooSmallTimespanWarning = true;
              }
            })
          }
          else if (type === 'availability_rule_saved') {
            this.$emit("work-hours-set", notification.availability_rule_saved);
          }
        }
    });
  },
  computed:{
    workHoursSet() {

    }
  },
}
</script>

<style lang="scss">
.work-hours-vue {
  .warning {
    color: $yellow;
    max-width: 900px;
  }
  #cronofy-availability-rules {
    max-width: 900px;
  }
  .work-hours-viewer {
    .work-hours-viewer__timezone-selector--option:hover {
      background-color: $green;
      color: $dark-blue;
      box-shadow: inset $blue 0 0 0 .1em;
      border-color: $blue;
    }
    .work-hours-viewer__timezone-selector--focused {
      background-color: $green;
      color: $dark-blue;
      box-shadow: inset $blue 0 0 0 .1em;
      border-color: $blue;
    }
    .work-hours-viewer__timezone-selector--option {
      color: $dark-blue;
    }
    .work-hours-viewer__timezone-selector--button:hover {
      background-color: $green;
      color: $dark-blue;
      box-shadow: inset $blue 0 0 0 .1em;
      border-color: $blue;
    }
    .work-hours-viewer__time-expander-button {
      svg {
        fill: $white;
      }
    }
    .work-hours-viewer__time-expander-button:hover {
      svg {
        fill: $green;
      }
    }
    .work-hours-viewer__confirmation {
      color: $light-gray;
      background-color: $blue;
      border-color: $green;
    }
    .work-hours-viewer__submit {
      color: $dark-blue;
    }
    .work-hours-viewer__calendars__calendar {
      background-color: $blue;
    }
  }

  .hideCalendars .work-hours-viewer .work-hours-viewer__calendars {
    display: none !important;
  }
}
</style>